var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.78766C2 9.42828 4.1671 11.5753 6.83238 11.5753C7.92839 11.5753 8.92475 11.2113 9.7343 10.6067L12.9787 13.8272C13.0908 13.9383 13.2465 14 13.4022 14C13.7634 14 14 13.7285 14 13.4015C14 13.2411 13.9377 13.0931 13.8319 12.982L10.5999 9.77378C11.2662 8.95321 11.6648 7.91671 11.6648 6.78766C11.6648 4.14704 9.49767 2 6.83238 2C4.1671 2 2 4.14704 2 6.78766ZM2.80955 6.78766C2.80955 4.59126 4.61546 2.80206 6.83238 2.80206C9.0493 2.80206 10.8552 4.59126 10.8552 6.78766C10.8552 8.98406 9.0493 10.7733 6.83238 10.7733C4.61546 10.7733 2.80955 8.98406 2.80955 6.78766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1beaaa4dd766042e33e88c741d9e7381.svg";
export { ForwardRef as ReactComponent };